// extracted by mini-css-extract-plugin
var _1 = "ConnectGoogle-module__button___OCmLQ";
var _2 = "ConnectGoogle-module__disabled___dBNFL";
var _3 = "ConnectGoogle-module__loading___Ses_R";
export { _1 as "button", _2 as "disabled", _3 as "loading" }
